import { render, staticRenderFns } from "./RepairList.vue?vue&type=template&id=63430837"
import script from "./RepairList.vue?vue&type=script&lang=js"
export * from "./RepairList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports